import React from 'react';
import { PageTitle } from '../instrument';

interface PageHeaderProps {
  icon: React.ReactNode;
  title: string;
  /** @deprecated Subtitles removed — parameter kept for backward compat but not rendered */
  subtitle?: string;
  gradient?: string;
  rightContent?: React.ReactNode;
  mb?: number;
}

/** Kept for pages not yet rebuilt; renders the instrument-panel PageTitle so every top matches. */
const PageHeader: React.FC<PageHeaderProps> = ({ icon, title, gradient, rightContent, mb = 1.5 }) => (
  <PageTitle title={title} icon={icon} gradient={gradient} right={rightContent} mb={mb} />
);

export default PageHeader;
